import { z } from 'zod';

export const companyNameSchema = (t: (key: string) => string) =>
  z.object({
    name: z
      .string()
      .min(1, t('company:settingsPage.inputs.companyName.errors.min'))
      .max(55, t('company:settingsPage.inputs.companyName.errors.max'))
      .regex(
        /^[а-яА-ЯёЁa-zA-Z0-9\s-]+$/,
        t('company:settingsPage.inputs.companyName.errors.pattern')
      )
      .refine((value) => value.trim().length > 0, {
        message: t('company:settingsPage.inputs.companyName.errors.min'),
      }),
  });

export const addEmployeeToCompanySchema = (t: (key: string) => string) =>
  z.object({
    email: z.string().email(t('common:errors.email')),
    departmentId: z.string().min(1, t('common:errors.required')),
    role: z.enum(['department_head', 'manager']),
    firstName: z.string().max(120).optional(),
    lastName: z.string().max(120).optional(),
  });
